import {
  base_colorAlert,
  base_colorContentBorder,
  input_backgroundDefault,
  input_borderDefault,
  tag_colorTagHighlightText,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;

  .CardSettingsTile-form {
    display: flex;
    flex-direction: column;
    gap: ${spacing(3)};
    max-width: 520px;
    padding-top: ${spacing(2)};
  }

  .CardSettingsTile-fieldRow {
    display: flex;
    gap: ${spacing(3)};
  }

  .CardSettingsTile-fieldRow > * {
    flex: 1;
  }

  .CardSettingsTile-field {
    display: flex;
    flex-direction: column;
    gap: ${spacing(1)};
  }

  .CardSettingsTile-label {
    font-family: ${font_family_weight_medium};
    ${font_sm};
    color: ${text_colorTextPrimary};
  }

  /* Matches the ext-ui TextInput "small" variant (36px container) so the
     country select lines up with the sibling inputs. */
  .CardSettingsTile-select {
    width: 100%;
    height: ${spacing(9)};
    padding: 0 ${spacing(2)};
    border: 1px solid ${input_borderDefault};
    border-radius: ${spacing(1)};
    background-color: ${input_backgroundDefault};
    color: ${text_colorTextPrimary};
    font-family: ${font_family_weight_regular};
    ${font_md};
  }

  .CardSettingsTile-formActions {
    display: flex;
    align-items: center;
    gap: ${spacing(3)};
  }

  .CardSettingsTile-savedNote {
    display: inline-flex;
    align-items: center;
    font-family: ${font_family_weight_regular};
    ${font_sm};
    color: ${tag_colorTagHighlightText};
  }

  .CardSettingsTile-errorNote {
    display: inline-flex;
    align-items: center;
    font-family: ${font_family_weight_regular};
    ${font_sm};
    color: ${base_colorAlert};
  }

  .CardSettingsTile-readOnlyNote {
    margin: 0;
    padding-top: ${spacing(2)};
    font-family: ${font_family_weight_regular};
    ${font_sm};
    color: ${text_colorTextSecondary};
  }

  .CardSettingsTile-kvList {
    margin: 0;
    padding-top: ${spacing(2)};
  }

  .CardSettingsTile-kv {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: ${spacing(4)};
    padding: ${spacing(2)} 0;
    border-bottom: 1px solid ${base_colorContentBorder};
  }

  .CardSettingsTile-kv:last-child {
    border-bottom: none;
  }

  .CardSettingsTile-kvLabel {
    margin: 0;
    font-family: ${font_family_weight_regular};
    ${font_md};
    color: ${text_colorTextSecondary};
  }

  .CardSettingsTile-kvValue {
    margin: 0;
    font-family: ${font_family_weight_medium};
    ${font_md};
    color: ${text_colorTextPrimary};
    font-variant-numeric: tabular-nums;
  }

  /* Spacing a disclosure's "Edit …" / "Manage …" drawer trigger away from the
     read-only summary above it (KV rows or control rows). Buttons are
     inline-block by default, so margin-top alone is enough here — no flex
     parent to lean on inside .SettingsDisclosure-content. */
  .CardSettingsTile-editTrigger {
    margin-top: ${spacing(3)};
  }
`
